import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './ProjectShowcase.css';
import project1 from '../Assets/images/Network Infrastructure.jpg';
import project2 from '../Assets/images/Suez Canal Development.jpg';
import project3 from '../Assets/images/Telecommunication Network.jpg';
import project4 from '../Assets/images/Suez Cement Factory.jpg';
import project5 from '../Assets/images/Sharm Elsheikh Airport Telecom.jpg';
import project6 from '../Assets/images/Military Personnel Information System.jpg';

const ProjectShowcase = () => {
  const projects = [
    {
      id: "01",
      location: "New Administrative Capital, Egypt",
      name: "Network Infrastructure - New Capital",
      context: "Negotiation and contracting of network infrastructure for the New Administrative Capital.",
      image: project1,
    },
    {
      id: "02",
      location: "Suez Canal Development Project, Egypt",
      name: "Suez Canal Development",
      context: "CPM-based planning for the execution of the Suez Canal Development Project.",
      image: project2,
    },
    {
      id: "03",
      location: "Etisalat Misr – Egypt",
      name: "Telecommunication Network Deployment",
      context: "Management of network deployment for Etisalat Misr.",
      image: project3,
    },
    {
      id: "04",
      location: "Suez Cement Factory – Arab Contractors",
      name: "Suez Cement Factory",
      context: "Construction management of the Suez Cement Factory for Arab Contractors.",
      image: project4,
    },
    {
      id: "05",
      location: "Sharm Elsheikh Airport – Egypt",
      name: "Sharm Elsheikh Airport Telecom",
      context: "Negotiation, contracting, and managing the Telecom Services Concession Project at Sharm Elsheikh Airport.",
      image: project5,
    },
    {
      id: "06",
      location: "Ministry of Defense – Egypt",
      name: "Military Personnel Information System",
      context: "Management of the Military Personnel Information System Project for the Ministry of Defense.",
      image: project6,
    },
  ];

  const [visibleProjects, setVisibleProjects] = useState(new Set());
  const projectRefs = useRef([]);

  useEffect(() => {
    const observers = [];

    projectRefs.current.forEach((element, index) => {
      if (!element) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const projectId = projects[index].id;
            
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              setVisibleProjects((prev) => new Set([...prev, projectId]));
            } else {
              setVisibleProjects((prev) => {
                const newSet = new Set(prev);
                newSet.delete(projectId);
                return newSet;
              });
            }
          });
        },
        {
          threshold: 0.5,
          rootMargin: '0px'
        }
      );

      observer.observe(element);
      observers.push(observer);
    });

    return () => {
      observers.forEach((observer) => observer.disconnect());
    };
  }, [projects]);

  return (
    <section className="project-section" id="projects">
      <div className="project-header-text">
        <h2 className="project-main-title">Strategic Execution, <br/> Technical Excellence</h2>
      </div>

      <div className="project-list">
        {projects.map((project, index) => (
          <div 
            key={project.id} 
            ref={(el) => (projectRefs.current[index] = el)}
            className={`project-row ${visibleProjects.has(project.id) ? 'is-visible' : ''}`}
          >
            <div className="project-info">
              <div className="project-meta">
                <span className="location-pin">📍</span>
                <span className="location-text">{project.location}</span>
              </div>
              <div className="project-title-group">
                <span className="project-number">{project.id}</span>
                <h3 className="project-name">{project.name}</h3>
              </div>
              {project.context && (
                <p className="project-context">{project.context}</p>
              )}
              <div className="underline-accent"></div>
            </div>
            
            <div className="project-image-container">
              <img src={project.image} alt={project.name} className="project-img" />
              <div className="image-overlay"></div>
            </div>
          </div>
        ))}
      </div>
      
      {/* Removed \"View All Projects\" button per latest requirements */}
    </section>
  );
};

export default ProjectShowcase;
